import React, { useEffect, useState, useContext } from "react";
import {
  Grid,
  Typography,
  Button,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Container,
  Skeleton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { NavLink, useLocation } from "react-router-dom";
import AlertMessage from "./modules/AlertMessage";
import { usePrice } from "./modules/PhonePriceListContext";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import "react-image-gallery/styles/css/image-gallery.css";
import "../styles/galleryImage.css";
import { setCanonicalTag } from "./modules/general";
import SdCardRoundedIcon from "@mui/icons-material/SdCardRounded";
import BatteryChargingFullRoundedIcon from "@mui/icons-material/BatteryChargingFullRounded";
import CropPortraitRoundedIcon from "@mui/icons-material/CropPortraitRounded";
import MemoryRoundedIcon from "@mui/icons-material/MemoryRounded";
import arrowRightPurple from "../image/icon/arrowRightPurple.png";
import arrowLeftPurple from "../image/icon/arrowLeftPurple.png";

export default function MobileDetail() {
  const location = useLocation();
  const { phoneData } = usePrice();
  const [item, setItem] = useState({});
  const itemData = location.pathname.split("/");
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [copyMessage, setCopyMessage] = useState("");

  useEffect(() => {
    const selectedItem = phoneData.find(
      (element) => element.id === parseInt(itemData[2]),
    );
    if (selectedItem) {
      setItem(selectedItem);
      setLoading(false);
    } else {
      setItem({});
      setLoading(true);
    }
  }, [phoneData, loading]);

  const separator = (value) => {
    value = value.toString();
    var place = 0;
    if (value.includes(".")) {
      place = value.indexOf(".");
      var num1 = value.slice(0, place);
      var num2 = value.slice(place + 1, value.length);
      value = camaInsert(num1, false) + "." + camaInsert(num2, true);
    } else {
      value = camaInsert(value);
    }
    return value;
  };

  function camaInsert(value, after = false) {
    var output = [];
    var outputString = "";
    if (after) {
      for (var i = 1; i <= value.length; i++) {
        if (i % 3 === 0) {
          output.push(value.slice(i - 3, i));
        }
      }
      if (value.length % 3 !== 0) {
        output.push(
          value.slice(value.length - (value.length % 3), value.length),
        );
      }

      for (var j = 0; j < output.length; j++) {
        if (j + 1 < output.length) {
          outputString = outputString + output[j] + ",";
        } else {
          outputString = outputString + output[j];
        }
      }
    } else {
      for (var p = 1; p <= value.length; p++) {
        if (p % 3 === 0) {
          output.push(value.slice(value.length - p, value.length - p + 3));
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(0, value.length % 3));
      }
      for (var o = output.length - 1; o >= 0; o--) {
        if (o > 0) {
          outputString = outputString + output[o] + ",";
        } else {
          outputString = outputString + output[o];
        }
      }
    }
    return outputString;
  }

  const swiperImage =
    item.image?.length > 0 ? item.image.map((img) => img.path) : [];
  const titleFa =
    item.brand && item.model
      ? `گوشی موبایل ${item.brand.name_fa} مدل ${item.model.name}`
      : "";
  const titleEn =
    item.brand && item.model
      ? `Mobile phone ${item.brand.name_en} model ${item.model.name}`
      : "";
  const priceString = (item.price !== 0 && item.price) || "";
  // const convertToNumber = priceString.replace(/,/g, "");
  // const priceMain = parseFloat(priceString);
  const spot = parseInt(priceString) + parseInt(0.024 * priceString);
  const cash = parseInt(priceString) + parseInt(0.043 * priceString);
  const total = parseInt(priceString) + parseInt(0.043 * priceString);
  // const pish = parseInt(total) * 0.35;
  const pish =
    parseInt(total) < 100000000
      ? parseInt(total) * 0.4
      : parseInt(total) >= 100000000 && parseInt(total) <= 200000000
        ? parseInt(total) * 0.5
        : parseInt(total) > 200000000
          ? parseInt(total) * 0.6
          : 0;
  const baghi = parseInt(total) - parseInt(pish);
  const soud = parseInt(baghi) * 0.035;

  // const galleryImages = swiperImage.map(image => ({
  //   original: image,
  //   thumbnail: image
  // }));

  useEffect(() => {
    document.title =
      (i18n.language === "fa" ? item.title_fa : item.title_en) || "";
    document.getElementById("main-heading").innerHTML =
      (i18n.language === "fa" ? item.h1_fa : item.h1_en) || "";
    document.getElementsByTagName("meta")["description"].content =
      (i18n.language === "fa" ? item.des_seo_fa : item.des_seo_en) || "";
    document.getElementsByTagName("meta")["keywords"].content =
      (i18n.language === "fa" ? item.key_fa : item.key_en) || "";
    document.getElementsByTagName("meta")["author"].content =
      "شرکت وب گستران سورین";
    setCanonicalTag();
  }, [item]);

  // const styles = {
  //   galleryContainer: {
  //     width: { xs: "80%", sm: "60%", md: "70%", xl: "80%", },
  //     margin: 'auto',
  //   },
  //   imageGallery: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //     alignItems: 'flex-start',
  //   },
  //   imageSlide: {
  //     display: 'block',
  //     width: '100%',
  //     maxWidth: '100%',
  //     cursor: "pointer",
  //     height: { xs: "200px", sm: "300px", md: "400px", xl: "500px" },
  //     objectFit: "cover"
  //   },
  //   thumbnailContainer: {
  //     display: 'flex',
  //     overflowY: 'auto',
  //     padding: '10px 0',
  //   },
  //   thumbnail: {
  //     borderRadius: '15px',
  //     marginRight: '10px',
  //   },
  //   thumbnailImage: {
  //     borderRadius: '15px',
  //     width: '100%',
  //     height: '100%',
  //   },
  //   arrowButton: {
  //     position: 'absolute',
  //     top: '50%',
  //     transform: 'translateY(-50%)',
  //     background: 'transparent',
  //     border: 'none',
  //     color: 'black',
  //     fontSize: '50px',
  //     cursor: 'pointer',
  //     zIndex: 1000,
  //   }
  // };

  const month = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const qestHarMah = (total, soud) => {
    let result = [];
    month.map((element, i) => {
      const qest = Math.round((total + soud * element) / element);
      result.push(
        <Grid
          key={i}
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            direction: i18n.language === "fa" ? "rtl" : "ltr",
            marginTop: "10px",
          }}
        >
          <Typography
            sx={{
              fontSize:
                i18n.language === "fa"
                  ? { xs: "13px", sm: "15px", xl: "20px" }
                  : "10px",
            }}
          >{`${element} ${t("month")}`}</Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize:
                i18n.language === "fa"
                  ? { xs: "13px", sm: "15px", xl: "20px" }
                  : "10px",
            }}
          >{`${separator(qest)} ${t("toman")}`}</Typography>
        </Grid>,
      );
    });
    return result;
  };

  const copyClipboard = async () => {
    const currentPath = window.location.pathname;
    try {
      await navigator.clipboard.writeText(window.location.origin + currentPath);
      setCopyMessage(t("copied"));
      setTimeout(() => {
        setCopyMessage("");
      }, 2000);
    } catch (error) {
      setCopyMessage("کپی نشد");
    }
  };

  return (
    <>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          width: "100%",
          direction: i18n.language === "fa" ? "rtl" : "ltr",
          backgroundColor: "white",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            width: "100%",
            backgroundColor: "#EDEDED",
            padding: "15px 0",
            justifyContent: "center",
          }}
        >
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              width: { xs: "95%", md: "86%" },
            }}
          >
            <NavLink className="navlink" to="/">
              <Typography
                component={"p"}
                sx={{ fontSize: "12px", color: "#757575", padding: "0 5px" }}
              >
                {t("mainPage")}
              </Typography>
            </NavLink>
            <ArrowBackIosIcon sx={{ fontSize: "15px" }} />
            <Typography
              component={"p"}
              sx={{ fontSize: "12px", color: "#757575", padding: "0 5px" }}
            >
              {t("priceList")}
            </Typography>
            <ArrowBackIosIcon sx={{ fontSize: "15px" }} />
            <Typography
              component={"p"}
              sx={{ fontSize: "12px", color: "#070707", padding: "0 5px" }}
            >
              {item.model?.name || ""}
            </Typography>
          </Grid>
        </Grid>
        {loading ? (
          <>
            <Skeleton
              variant="rounded"
              animation="wave"
              sx={{
                width: "100%",
                height: { xs: "54px", sm: "46px", md: "57px" },
                margin: "10px 0",
              }}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              sx={{
                width: "100%",
                height: { xs: "54px", sm: "46px", md: "57px" },
                margin: "10px 0",
              }}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              sx={{
                width: "100%",
                height: { xs: "54px", sm: "46px", md: "57px" },
                margin: "10px 0",
              }}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              sx={{
                width: "100%",
                height: { xs: "54px", sm: "46px", md: "57px" },
                margin: "10px 0",
              }}
            />
          </>
        ) : (
          <>
            <Grid
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: "2em",
                flexDirection: "row",
              }}
            >
              <Typography
                component={"h3"}
                sx={{
                  fontSize: { xs: "12px", sm: "17px", md: "20px", lg: "27px" },
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                {i18n.language === "fa" ? titleFa : titleEn}
              </Typography>
            </Grid>
            <Grid
              sx={{
                width: { lg: "65%", xs: "95%" },
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
                flexWrap: "wrap",
                justifyContent: { xs: "unset", lg: "space-between" },
                alignItems: "center",
                marginTop: "2em",
              }}
            >
              <Grid
                sx={{
                  width: { xs: "80%", lg: "45%" },
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Grid
                  sx={{
                    width: { xs: "100%", md: "80%", lg: "100%" },
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "10px",
                  }}
                >
                  <Swiper
                    style={{
                      "--swiper-pagination-color": "#FF3951",
                    }}
                    modules={[Pagination]}
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                      reverseDirection: true,
                      waitForTransition: true,
                    }}
                    className="mySwiper"
                    pagination={{
                      clickable: true,
                      slidesPerView: 1,
                      spaceBetween: 10,
                    }}
                    speed={1200}
                    loop={true}
                    centeredSlides={true}
                    roundLengths={true}
                    mousewheel={true}
                    grabCursor={true}
                  >
                    {swiperImage.map((item, i) => (
                      <SwiperSlide key={i}>
                        <Grid
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            component={"img"}
                            alt={`${titleFa}${i}`}
                            src={item}
                            sx={{
                              width: "100%",
                              height: { xs: "250px", md: "350px", xl: "500px" },
                            }}
                          />
                        </Grid>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: { xs: "80%", lg: "40%" },
                  marginTop: { xs: "1em", lg: "unset" },
                  borderRadius: "10px",
                  boxShadow: "0px 0px 10px 0px #888484ff",
                }}
              >
                <Grid
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "10px",
                    justifyContent: "center",
                  }}
                >
                  <Grid
                    sx={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      direction: i18n.language === "fa" ? "rtl" : "ltr",
                      marginRight: "5px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#FF3951",
                        fontSize: {
                          xl: "20px",
                          lg: "20px",
                          xs: "12px",
                          sm: "15px",
                          md: "18px",
                        },
                      }}
                    >
                      {t("consumerPrice")}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#FF3951",
                        fontWeight: "bold",
                        fontSize: {
                          xl: "20px",
                          lg: "20px",
                          xs: "12px",
                          sm: "15px",
                          md: "18px",
                        },
                      }}
                    >
                      {cash !== 0
                        ? `${separator(cash)} ${t("toman")}`
                        : t("outOfStock")}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "10px",
                    justifyContent: "center",
                  }}
                >
                  <Grid
                    sx={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      direction: i18n.language === "fa" ? "rtl" : "ltr",
                      marginRight: "5px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#f88e2bff",
                        fontSize: {
                          xl: "20px",
                          lg: "20px",
                          xs: "12px",
                          sm: "15px",
                          md: "18px",
                        },
                      }}
                    >
                      {t("spotSalePrice")}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#f88e2bff",
                        fontWeight: "bold",
                        fontSize: {
                          xl: "20px",
                          lg: "20px",
                          xs: "12px",
                          sm: "15px",
                          md: "18px",
                        },
                      }}
                    >
                      {spot !== 0
                        ? `${separator(spot)} ${t("toman")}`
                        : t("outOfStock")}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "1em",
                  }}
                >
                  <Grid
                    sx={{
                      width: "85%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      direction: i18n.language === "fa" ? "rtl" : "ltr",
                    }}
                  >
                    <Typography
                      sx={{
                        display: "flex",
                        alignSelf: "flex-start",
                        fontWeight: "bold",
                        fontSize: { xs: "15px", lg: "18px", xl: "20px" },
                        color: "#7F04FB",
                      }}
                    >
                      {t("aqsat")}
                    </Typography>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Grid
                        sx={{
                          width: { xl: "15px", xs: "10px", md: "11px" },
                          height: { xl: "15px", xs: "10px", md: "11px" },
                          backgroundColor: `#${item.color?.hex || "transparent"}`,
                          border: "1px solid gray",
                          borderRadius: "3px",
                        }}
                      ></Grid>
                      <Typography
                        sx={{
                          padding: "0px 5px 0px 5px",
                          fontSize: { xl: "15px", xs: "12px", md: "15px" },
                        }}
                      >
                        {i18n.language === "fa"
                          ? item.color?.name_fa
                          : item.color?.name_en || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      width: "90%",
                      height: "1px",
                      backgroundColor: "#BABABA",
                    }}
                  ></Grid>
                  <Grid
                    sx={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      direction: i18n.language === "fa" ? "rtl" : "ltr",
                      marginTop: "1em",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize:
                          i18n.language === "fa"
                            ? { xs: "13px", sm: "15px", xl: "20px" }
                            : "10px",
                      }}
                    >
                      {t("prepayment")}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize:
                          i18n.language === "fa"
                            ? { xs: "13px", sm: "15px", xl: "20px" }
                            : "10px",
                      }}
                    >
                      {pish !== 0
                        ? `${separator(Math.floor(pish))} ${t("toman")}`
                        : t("outOfStock")}
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{
                      width: "90%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "space-between",
                      direction: i18n.language === "fa" ? "rtl" : "ltr",
                      overflowY: "scroll",
                      paddingTop: { xs: "9em", sm: "10em", xl: "13em" },
                      height: { xs: "70px", xl: "200px" },
                    }}
                  >
                    {qestHarMah(baghi, soud)}
                  </Grid>
                  {/* {qestHarMah(baghi, soud)} */}
                </Grid>
                <Grid
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginTop: { xs: "1.5em", lg: "2.5em" },
                    marginBottom: "1em",
                  }}
                >
                  <Button
                    onClick={copyClipboard}
                    sx={{
                      bgcolor: "#FF3951",
                      width: {
                        xs: "45%",
                        sm: "40%",
                        md: "40%",
                        lg: "40%",
                        xl: "40%",
                      },
                      height: {
                        xs: "35px",
                        sm: "38px",
                        md: "42px",
                        lg: "45px",
                        xl: "47px",
                      },
                      boxShadow: " #FF3951 0px 0px 15px",
                      "&:hover": { backgroundColor: "#FF3951" },
                      borderRadius: "8px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      alignSelf: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontSize: {
                          xs: "13px",
                          sm: "11px",
                          md: "16px",
                          lg: "15px",
                          xl: "17px",
                        },
                      }}
                    >
                      {copyMessage ? copyMessage : t("share")}
                    </Typography>
                  </Button>
                  <Grid
                    sx={{
                      bgcolor: `${item.color?.hex === "FFFFFF" ? "#FF3951" : `#${item.color?.hex}`}`,
                      width: {
                        xs: "45%",
                        sm: "40%",
                        md: "40%",
                        lg: "40%",
                        xl: "40%",
                      },
                      height: {
                        xs: "35px",
                        sm: "38px",
                        md: "42px",
                        lg: "45px",
                        xl: "47px",
                      },
                      boxShadow: `${item.color?.hex === "FFFFFF" ? "#FF3951" : `#${item.color?.hex}`} 0px 0px 15px`,
                      "&:hover": {
                        backgroundColor: `${item.color?.hex === "FFFFFF" ? "#FF3951" : `#${item.color?.hex}`}`,
                      },
                      borderRadius: "8px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      alignSelf: "center",
                    }}
                  >
                    <NavLink
                      to="/MobilePhonePriceList"
                      className="navlink"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "center",
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13px",
                            sm: "11px",
                            md: "16px",
                            lg: "15px",
                            xl: "17px",
                          },
                        }}
                      >
                        {t("priceList")}
                      </Typography>
                    </NavLink>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              sx={{
                width: { xs: "75%", lg: "70%" },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  flexWrap: "wrap",
                  justifyContent: { xs: "unset", lg: "space-evenly" },
                  marginTop: "1em",
                }}
              >
                <Grid
                  sx={{
                    width: "100%",
                    borderRadius: "10px",
                    boxShadow: "0px 0px 10px 0px #888484ff",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "2em",
                    height: "100%",
                    overflow: "scroll",
                  }}
                >
                  <Grid
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                    }}
                  >
                    <Grid
                      sx={{
                        width: "33%",
                        height: { xs: "80px", md: "100px" },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <CropPortraitRoundedIcon
                        sx={{
                          fontSize: { xs: "20px", md: "25px", xl: "30px" },
                          color: `${item.color?.hex === "FFFFFF" ? "#FF3951" : `#${item.color?.hex}`}`,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "10px",
                            sm: "15px",
                            md: "18px",
                            xl: "20px",
                          },
                          fontWeight: 600,
                        }}
                      >
                        {i18n.language === "fa"
                          ? `"${item.size?.inch}`
                          : `${item.size?.inch}"` || ""}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        width: "33%",
                        height: { xs: "80px", md: "100px" },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <SdCardRoundedIcon
                        sx={{
                          fontSize: { xs: "20px", md: "25px", xl: "30px" },
                          color: `${item.color?.hex === "FFFFFF" ? "#FF3951" : `#${item.color?.hex}`}`,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "10px",
                            sm: "15px",
                            md: "18px",
                            xl: "20px",
                          },
                          fontWeight: 600,
                          textAlign: "center",
                        }}
                      >
                        {item.hdd || ""}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        width: "33%",
                        height: { xs: "80px", md: "100px" },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <MemoryRoundedIcon
                        sx={{
                          fontSize: {
                            xs: "20px",
                            xl: "30px",
                            md: "25px",
                            color: `${item.color?.hex === "FFFFFF" ? "#FF3951" : `#${item.color?.hex}`}`,
                          },
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "10px",
                            sm: "15px",
                            xl: "20px",
                            md: "18px",
                          },
                          fontWeight: 600,
                        }}
                      >
                        {item.ram || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        direction: i18n.language === "fa" ? "rtl" : "ltr",
                        marginTop: "1em",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontSize: { lg: "15px", xs: "10px", sm: "15px" },
                        }}
                      >
                        {t("rgeion")}
                      </Typography>
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "15px",
                            xl: "20px",
                            lg: "14px",
                          },
                        }}
                      >
                        {i18n.language === "fa"
                          ? item.regin?.name_fa
                          : item.regin?.name_en || ""}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        direction: i18n.language === "fa" ? "rtl" : "ltr",
                        marginTop: "1em",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontSize: { lg: "15px", xs: "10px", sm: "15px" },
                        }}
                      >
                        {t("cpu")}
                      </Typography>
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "15px",
                            xl: "20px",
                            lg: "14px",
                          },
                          textAlign: "left",
                        }}
                      >
                        {item.proccess || ""}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        direction: i18n.language === "fa" ? "rtl" : "ltr",
                        marginTop: "1em",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontSize: { lg: "15px", xs: "10px", sm: "15px" },
                        }}
                      >
                        {t("weight")}
                      </Typography>
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "15px",
                            xl: "20px",
                            lg: "14px",
                          },
                        }}
                      >
                        {`${item.weight}g` || ""}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        direction: i18n.language === "fa" ? "rtl" : "ltr",
                        marginTop: "1em",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontSize: { lg: "15px", xs: "10px", sm: "15px" },
                        }}
                      >
                        {t("gpu")}
                      </Typography>
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "15px",
                            xl: "20px",
                            lg: "14px",
                          },
                        }}
                      >
                        {item.vga || ""}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        direction: i18n.language === "fa" ? "rtl" : "ltr",
                        marginTop: "1em",
                        marginBottom: "10px",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontSize: { lg: "15px", xs: "10px", sm: "15px" },
                        }}
                      >
                        {t("battery")}
                      </Typography>
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "15px",
                            xl: "20px",
                            lg: "14px",
                          },
                          textAlign: "left",
                        }}
                      >
                        {item.battery || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                mt: { xs: "2em", lg: "4em" },
              }}
            >
              <Typography
                component={"img"}
                alt="icon"
                src={arrowRightPurple}
                sx={{
                  width: { xs: "10px", sm: "20px", md: "30px", lg: "54px" },
                  height: { xs: "17px", sm: "53px", md: "55px", lg: "69px" },
                  margin: "0 3px",
                }}
              />
              <Typography
                component={"h2"}
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "13px", sm: "17px", md: "25px" },
                }}
              >
                {t("registerd")}
              </Typography>
              <Typography
                component={"img"}
                alt="icon"
                src={arrowLeftPurple}
                sx={{
                  width: { xs: "10px", sm: "20px", md: "30px", lg: "54px" },
                  height: { xs: "17px", sm: "53px", md: "55px", lg: "69px" },
                  margin: "0 3px",
                }}
              />
            </Grid>
            <Grid
              sx={{
                width: { xs: "95%", lg: "70%" },
                marginTop: "1em",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxShadow: "0px 0px 10px 0px #FF3951",
                borderRadius: "10px",
                padding: "10px 0px 10px 0px",
                marginBottom: "1em",
              }}
            >
              <Typography
                sx={{
                  fontSize: "25px",
                  color: "#7F04FB",
                  display: "flex",
                  justifyContent: i18n.language === "fa" ? "start" : "unset",
                  padding: "10px 0px 10px 0px",
                  width: "90%",
                }}
              >
                {t("generalSpecifications")}
              </Typography>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  padding: "5px 0px",
                  backgroundColor: "#FAFAFA",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("colorPro")}
                </Typography>
                <Grid
                  sx={{ display: "flex", flexDirection: "row", width: "90%" }}
                >
                  <Grid
                    sx={{
                      width: { xs: "30%", xl: "20%" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xl: "15px", xs: "10px", md: "11px" },
                        height: { xl: "15px", xs: "10px", md: "11px" },
                        backgroundColor: `#${item.color?.hex || "transparent"}`,
                        border: "1px solid gray",
                        borderRadius: "3px",
                      }}
                    ></Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: { xs: "70%", xl: "80%" },
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        direction: "ltr",
                        fontSize: {
                          xs: "8px",
                          sm: "10px",
                          md: "12px",
                          lg: "14px",
                          xl: "17px",
                        },
                      }}
                    >
                      {i18n.language === "fa"
                        ? item.color?.name_fa
                        : item.color?.name_en || ""}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("network")}
                </Typography>
                <Grid
                  sx={{ display: "flex", flexDirection: "row", width: "90%" }}
                >
                  <Grid
                    sx={{
                      width: { xs: "30%", xl: "20%" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "15px",
                          lg: "17px",
                          xl: "20px",
                        },
                      }}
                    >
                      {t("technology")}
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: { xs: "70%", xl: "80%" },
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        direction: "ltr",
                        fontSize: {
                          xs: "8px",
                          sm: "10px",
                          md: "12px",
                          lg: "14px",
                          xl: "17px",
                        },
                      }}
                    >
                      {item.network || ""}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("launch")}
                </Typography>
                <Grid
                  sx={{ display: "flex", flexDirection: "row", width: "90%" }}
                >
                  <Grid
                    sx={{
                      width: { xs: "30%", xl: "20%" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "15px",
                          lg: "17px",
                          xl: "20px",
                        },
                      }}
                    >
                      {t("presentation")}
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: { xs: "70%", xl: "80%" },
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        direction: "ltr",
                        fontSize: {
                          xs: "8px",
                          sm: "10px",
                          md: "12px",
                          lg: "14px",
                          xl: "17px",
                        },
                      }}
                    >
                      {item.lunch || ""}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("body")}
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    width: "90%",
                    flexDirection: "column",
                  }}
                >
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("dimension")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: {
                          xs: "70%",
                          xl: "80%",
                          justifyContent: "center",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                        }}
                      >
                        {`${item.size?.inch}"` || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("weight")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: {
                          xs: "70%",
                          xl: "80%",
                          justifyContent: "center",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                        }}
                      >
                        {`${item.weight}g` || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("simNumber")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: {
                          xs: "70%",
                          xl: "80%",
                          justifyContent: "center",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                        }}
                      >
                        {item.sim || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("display")}
                </Typography>
                <Grid
                  sx={{ display: "flex", flexDirection: "row", width: "90%" }}
                >
                  <Grid
                    sx={{
                      width: { xs: "30%", xl: "20%" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "15px",
                          lg: "17px",
                          xl: "20px",
                        },
                      }}
                    >
                      {t("screenTechnology")}
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: { xs: "70%", xl: "80%" },
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        direction: "ltr",
                        fontSize: {
                          xs: "8px",
                          sm: "10px",
                          md: "12px",
                          lg: "14px",
                          xl: "17px",
                        },
                      }}
                    >
                      {item.type_display || ""}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("platform")}
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    width: "90%",
                    flexDirection: "column",
                  }}
                >
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("os")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                        }}
                      >
                        {item.os || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("cpu")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                        }}
                      >
                        {item.proccess || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("gpu")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                        }}
                      >
                        {item.vga || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("memory")}
                </Typography>
                <Grid
                  sx={{ display: "flex", flexDirection: "row", width: "90%" }}
                >
                  <Grid
                    sx={{
                      width: { xs: "30%", xl: "20%" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "15px",
                          lg: "17px",
                          xl: "20px",
                        },
                      }}
                    >
                      {t("internal")}
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: { xs: "70%", xl: "80%" },
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        direction: "ltr",
                        fontSize: {
                          xs: "8px",
                          sm: "10px",
                          md: "12px",
                          lg: "14px",
                          xl: "17px",
                        },
                      }}
                    >
                      {item.hdd || ""}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("mainCamera")}
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    width: "90%",
                    flexDirection: "column",
                  }}
                >
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("MCresolution")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                          textAlign: "center",
                        }}
                      >
                        {item.main_camera_mou || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("MCfeature")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                          textAlign: "center",
                        }}
                      >
                        {item.main_camera_fea || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("MCvideo")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                          textAlign: "center",
                        }}
                      >
                        {item.main_camera_vid || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("selfieCamera")}
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    width: "90%",
                    flexDirection: "column",
                  }}
                >
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("SFresolution")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                          textAlign: "center",
                        }}
                      >
                        {item.selfi_camera_mou || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("SFfeature")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                          textAlign: "center",
                        }}
                      >
                        {item.selfi_camera_fea || "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("SFvideo")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                          textAlign: "center",
                        }}
                      >
                        {item.selfi_camera_vid || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  direction: i18n.language === "fa" ? "rtl" : "ltr",
                  backgroundColor: "#FAFAFA",
                  padding: "5px 0px",
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "red",
                    fontWeight: "bold",
                    width: "10%",
                    fontSize: { xs: "10px", sm: "unset", xl: "20px" },
                    paddingRight: i18n.language === "fa" ? "10px" : "0px",
                  }}
                >
                  {t("battery")}
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    width: "90%",
                    flexDirection: "column",
                  }}
                >
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("typeBattery")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                        }}
                      >
                        {item.battery || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      borderBottom: "1px solid #EDEDED",
                    }}
                  >
                    <Grid
                      sx={{
                        width: { xs: "30%", xl: "20%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "15px",
                            lg: "17px",
                            xl: "20px",
                          },
                        }}
                      >
                        {t("charge")}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "70%", xl: "80%" },
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          direction: "ltr",
                          fontSize: {
                            xs: "8px",
                            sm: "10px",
                            md: "12px",
                            lg: "14px",
                            xl: "17px",
                          },
                        }}
                      >
                        {item.charging || "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
        <Typography component={"p"} sx={{ display: "none" }}>
          {item.des || ""}
        </Typography>
      </Grid>
    </>
  );
}
